import { DateTime } from 'luxon';

export const isDateRangeValid = value =>
  Array.isArray(value) &&
  value.length === 2 &&
  value.every(
    date =>
      DateTime.fromISO(date) instanceof DateTime &&
      DateTime.fromISO(date).isValid,
  ) &&
  DateTime.fromISO(value[0]) <= DateTime.fromISO(value[1]);
